import { useEffect } from "react";
import { tokenSupplier } from "../../../services/axios/webAuth";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
export default function SignOutPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    console.log("doing signout hook");
    tokenSupplier.signOut().then(() => {
      console.log("signed out of auth providers");
      dispatch({ type: "SIGNOUT_CLEAR_STORE" });
      console.log("cleared redux store");
      navigate("/");
    });
  }, []);

  return <h1>Logging you out...</h1>;
}
